// REACT
import { createBrowserRouter } from "react-router-dom"

// Components
import MainLayout from "../components/layout/MainLayout.js"

// Pages
import Home from "../pages/Home.js"
import CompanyInfo from "../pages/CompanyInfo.js"
import Gallery from "../pages/Gallery.js"
import Trainers from "../pages/Trainers.js"
import News from "../pages/News.js"
import Services from "../pages/Services.js"
import About from "../pages/About.js"
import Pricelist from "../pages/Pricelist.js"
import TimeTable from "../pages/TimeTable.js"
import Career from "../pages/Career.js"
import ErrorPage from "../pages/ErrorPage.js"
import NotFound from "../pages/NotFound.js"

export const router = createBrowserRouter([
    {
        path: "/",
        element: <MainLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: "*",
                element: <NotFound />
            },
            {
                path: "/",
                element: <Home />
            },
            {
                path: "/szolgaltatasok",
                element: <Services />
            },
            {
                path: "/arlista",
                element: <Pricelist />
            },
            {
                path: "/rolunk",
                element: <About />
            },
            {
                path: "/hirek",
                element: <News />,
            },
            {
                path: "/edzok",
                element: <Trainers />
            },
            {
                path: "/orarend",
                element: <TimeTable />
            },
            {
                path: "/galeria",
                element: <Gallery />
            },
            {
                path: "/karrier",
                element: <Career />
            },
            {
                path: "/impresszum",
                element: <CompanyInfo />
            },
        ]
    }
])